import {useQuery, useMutation} from '@apollo/client'
import {Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {GET_SYSTEM_EMAIL_SETTINGS} from '../../../gql/queries/emailSettingsQuery'
import {SEND_TEST_EMAIL, UPDATE_SYSTEM_EMAIL_SETTINGS} from '../../../gql/mutations/emailSettingsMutations'
import {EmailSettingsForm, IEmailSettingsValues} from '../../shared/EmailSettingsForm'

export const EmailSettingsTab = () => {
  const {data, loading, refetch} = useQuery(GET_SYSTEM_EMAIL_SETTINGS, {fetchPolicy: 'network-only'})
  const [updateSystemEmailSettings, {loading: saving}] = useMutation(UPDATE_SYSTEM_EMAIL_SETTINGS)
  const [sendTestEmail, {loading: sendingTestEmail}] = useMutation(SEND_TEST_EMAIL)

  const settings = data?.systemEmailSettings

  const handleSendTestEmail = async (toEmail: string) => {
    try {
      const res = await sendTestEmail({variables: {toEmail}})
      const result = res.data?.sendTestEmail
      if (!result?.success) {
        toast.error(result?.errors?.map((e: any) => e.message).join('\n') || 'Error sending test email')
        return
      }
      toast.success(`Test email sent to ${toEmail}`)
    } catch (err: any) {
      toast.error(err.message || 'Error sending test email')
    }
  }

  const handleSave = async (input: IEmailSettingsValues) => {
    try {
      const res = await updateSystemEmailSettings({variables: {input}})
      const result = res.data?.updateSystemEmailSettings
      if (!result?.success) {
        toast.error(result?.errors?.map((e: any) => e.message).join('\n') || 'Error saving Email Settings')
        return
      }
      toast.success('Email Settings saved')
      refetch()
    } catch (err: any) {
      toast.error(err.message || 'Error saving Email Settings')
    }
  }

  if (loading) {
    return (
      <div className='text-center py-6'>
        <Spinner animation='border' size='sm' />
      </div>
    )
  }

  return (
    <div>
      <p className='text-muted mb-4' style={{fontSize: '0.85rem'}}>
        Default system configuration: sender and signature used when an Organization or User doesn't have
        its own override.
      </p>
      <EmailSettingsForm
        values={settings}
        showInheritance={false}
        saving={saving}
        onSave={handleSave}
        onSendTestEmail={handleSendTestEmail}
        sendingTestEmail={sendingTestEmail}
      />
    </div>
  )
}
